import React, { Component } from 'react';
import { render } from 'react-dom';
import { connect } from 'react-redux'
import { v4 } from 'uuid'
import Topbar from '../Topbar/';
import JitsuLoader from '../JitsuLoader/';


import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Avatar from '@material-ui/core/Avatar';

import { sendChatNotification, getUserConversations, searchContacts, acceptConversationRequest } from './actions';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    type: 'dark',
  },
});

class ConversationsComponet extends Component {
  constructor() {
    super();
    this.state = {
      showLoader: false
    }
  }

  selectAddContact = () => {

    window.location.hash = "add-contact"

  }

  selectContact = (conversationData) => {
    this.setState({
      showLoader: true
    })
    this.props.sendChatNotification({
      conversationData
    })

  }

  componentDidMount = () => {
    var {user: {uid}} = this.props
    if (uid) {

      this.props.getUserConversations()
    }

  }

  searchContacts = () => {

    console.log("search term", this.state.searchTerm)

    this.props.searchContacts(this.state.searchTerm)

      .then(profilesResponse => {

        console.log("profilesResponse", profilesResponse)

      })

  }

  acceptConversationRequest = async(conversationData) => {

    await this.props.acceptConversationRequest(conversationData)

    this.setState({
      showLoader: true
    })

    this.props.sendChatNotification({
      conversationData
    })

  }

  render() {

    var {list} = this.props.conversations

    return (
      <MuiThemeProvider theme={ theme }>
        <div style={ { backgroundColor: 'black' } } className="h-100 convo-screen d-flex flex-column">
          <Topbar/>
          <br/>
          <Button className="m-2 animated slideInUp" onClick={ () => this.selectAddContact() } variant="contained" color="primary">
            add Contact
          </Button>
          <hr className="w-100" />
          <div className="flex-1 scroll-y animated slideInLeft">
            <List>
              { list && list.map(conversationData => {
                  var contactLabel = conversationData.contactEmail || `Waiting for ${ conversationData.waitingContactInfo }`
                  if (conversationData.waitingUserId && conversationData.contactEmail) {
                
                    contactLabel = `Request : ${conversationData.contactEmail}`
                
                  }
                  return ( <ListItem onClick={ (event) => {
                                    
                                      if (conversationData.contactEmail) {
                                    
                                        if (conversationData.waitingUserId) {
                                    
                                          this.acceptConversationRequest(conversationData)
                                    
                                        } else {
                                    
                                          this.selectContact(conversationData)
                                    
                                        }
                                    
                                      }
                                    
                                    } } key={ v4() } dense button>
                             { conversationData.photolink && <Avatar alt="Remy Sharp" src={ conversationData.photolink } /> }
                             <ListItemText style={ { fontSize: '3vh', fontFamily: 'Gloria Hallelujah' } }>
                               <span style={ { fontSize: '3vh', fontFamily: 'Gloria Hallelujah' } }>{ contactLabel }</span>
                             </ListItemText>
                           </ListItem>)
                }) }
            </List>
          </div>
          { this.state.showLoader && <JitsuLoader/> }
        </div>
      </MuiThemeProvider>

      );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  conversations: state.conversations,

})

const Conversations = connect(mapStateToProps, {
  sendChatNotification,
  getUserConversations,
  searchContacts,
  acceptConversationRequest
})(ConversationsComponet)

export default Conversations


// WEBPACK FOOTER //
// ./src/Components/Conversations/index.js